import { t } from '@lingui/core/macro'
import Tooltip from '@mui/material/Tooltip'
import { CvsAutoComplete } from '@components'
import { colors } from '@global/constants'
import { IntegrationFilter } from './filter-types'

type filterState = 'loading' | 'waiting_on_account' | 'ready'
export interface FiltersState {
  state: filterState
  message: string
}

interface Props {
  availableFilters: IntegrationFilter[]
  assignFilter: (filter: IntegrationFilter) => void
  filtersState: FiltersState
}

export const AddFilter = ({ availableFilters, assignFilter, filtersState }: Props) => {
  function handleFilterOptionClick(filterKey: string): void {
    const filter = availableFilters.find(f => f.filterKey == filterKey)

    if (filter) {
      assignFilter(filter)
    }
  }

  const AddFilterOption = {
    label: t`Add Filter`,
    value: t`Add Filter`,
  }

  const baseGray = '#00000042'
  const disabledGray = '#0000001f'

  if (!availableFilters.length && filtersState.state === 'ready') {
    filtersState.message = t`No available filters`
  }

  return (
    <Tooltip placement="right" title={filtersState.message} arrow>
      <div style={{ width: 155 }}>
        <CvsAutoComplete
          id="add-filter-select"
          selected={AddFilterOption.value}
          isLoading={filtersState.state === 'loading'}
          margin="dense"
          style={{
            width: 160,
            marginBottom: 15,
          }}
          onSelected={handleFilterOptionClick}
          isDisabled={availableFilters.length == 0}
          options={
            availableFilters.map(f => ({
              value: f.filterKey,
              label: f.displayName,
            })) as any
          }
          allOptions={
            availableFilters
              .map(f => ({
                value: f.filterKey,
                label: f.displayName,
              }))
              .concat([AddFilterOption]) as any
          }
          styleOverrides={{
            input: base => ({
              ...base,
              color: `${colors.blue.main} !important`,
              fontSize: '12 !important',
            }),
            container: base => ({
              ...base,
              '& .MuiFormControl-root': {
                ...(availableFilters.length
                  ? {
                      backgroundColor: 'initial !important',
                    }
                  : {}),
              },
              '& .MuiOutlinedInput-root': {
                cursor: 'pointer',
                height: 33,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: `${
                  availableFilters.length ? colors.blue.main : disabledGray
                } !important`,
              },
              '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: `${
                  availableFilters.length ? colors.blue.main : disabledGray
                } !important`,
              },
              '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: `${
                  availableFilters.length ? colors.blue.main : disabledGray
                } !important`,
                borderWidth: 1,
              },
              '& .Mui-focused': {
                borderColor: `${
                  availableFilters.length ? colors.blue.main : disabledGray
                } !important`,
              },
              '& .MuiTypography-body1': {
                color: `${availableFilters.length ? colors.blue.main : baseGray} !important`,
                marginLeft: '10 !imporant',
              },
              '& .makeStyles-singleValue-54': {
                color: `${availableFilters.length ? colors.blue.main : baseGray} !important`,
                marginLeft: '10 !imporant',
                fontSize: '12 !imporant',
              },
              '& .makeStyles-inputDense-49': {
                paddingLeft: '3 !important',
              },
            }),
            dropdownIndicator: base => ({
              ...base,
              color: `${availableFilters.length ? colors.blue.main : baseGray} !important`,
            }),
            indicatorSeparator: base => ({
              ...base,
              backgroundColor: `${
                availableFilters.length ? colors.blue.main : baseGray
              } !important`,
            }),
            menuPortal: base => ({
              ...base,
              width: 175,
            }),
            menu: base => ({
              ...base,
              width: 175,
            }),
          }}
        />
      </div>
    </Tooltip>
  )
}
